var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import moment from "moment";
import ProfilePicture from "@irati/ui/src/ProfilePicture";
import { FormattedDate } from "@irati/utils/lang";
import { Para } from "../../ui/Labels";
import AnonimousProfilePhoto from "../../../images/Anonymous.svg";
var Header = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var UserName = styled(Para)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 10px;\n"], ["\n  margin-left: 10px;\n"])));
var MessageHeader = function (_a) {
    var user = _a.user, date = _a.date;
    var defaultUser = { profile_img: AnonimousProfilePhoto };
    return (React.createElement(Header, null,
        React.createElement(ProfilePicture, { user: user || defaultUser, defaultImageOverride: AnonimousProfilePhoto, regular: true }),
        React.createElement(UserName, { bold: true, flush: true },
            user ? user.firstname + " " + user.lastname : "Anonymous",
            date && (React.createElement(React.Fragment, null,
                ", ",
                React.createElement(FormattedDate, { value: moment(date).toDate(), month: "numeric", day: "numeric", year: "numeric", hour: "numeric", minute: "numeric" }))))));
};
export default MessageHeader;
var templateObject_1, templateObject_2;
